import { render } from "./CourseRightSide.vue?vue&type=template&id=196ee71d"
import script from "./CourseRightSide.vue?vue&type=script&lang=js"
export * from "./CourseRightSide.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__